import { useQuery } from '@tanstack/react-query';

import { getUsers } from '../api/users';
import { Queries } from '../types/queries';

/** Loads the user-management list when the current caller can access it. */
const useUsers = (enabled = true) =>
  useQuery({
    queryKey: [Queries.UserList],
    queryFn: getUsers,
    enabled,
    refetchOnWindowFocus: false,
  });

export default useUsers;
